import { render, staticRenderFns } from "./nineGrid.vue?vue&type=template&id=e5229096&scoped=true&"
import script from "./nineGrid.vue?vue&type=script&lang=js&"
export * from "./nineGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5229096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5229096')) {
      api.createRecord('e5229096', component.options)
    } else {
      api.reload('e5229096', component.options)
    }
    module.hot.accept("./nineGrid.vue?vue&type=template&id=e5229096&scoped=true&", function () {
      api.rerender('e5229096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/nineGrid.vue"
export default component.exports